export const ambassadors = [
  {
    Name: "Erikan Baluku",
    Region: "Africa",
    Country: "Uganda",
    City: "Kampala",
    Latitude: 0.3475964,
    Longitude: 32.5825197,
  },
  {
    Name: "Sara Ghoul",
    Region: "Africa",
    Country: "Belgium",
    City: "Brussels",
    Latitude: 50.8503396,
    Longitude: 4.3517103,
  },
  {
    Name: "Youssef Abdelmaksoud",
    Region: "Africa",
    Country: "Egypt",
    City: "Cairo",
    Latitude: 30.0444196,
    Longitude: 31.2357116,
  },
  {
    Name: "Alex Kyabarongo",
    Region: "Africa",
    Country: "Uganda",
    City: "Kampala",
    Latitude: 0.3475964,
    Longitude: 32.5825197,
  },
  {
    Name: "Avadhoot Jadhav",
    Region: "Asia",
    Country: "India",
    City: "Pune",
    Latitude: 18.5204303,
    Longitude: 73.8567437,
  },
  {
    Name: "Ayesha Sameer",
    Region: "Asia",
    Country: "UAE",
    City: "Abu Dhabi",
    Latitude: 24.453884,
    Longitude: 54.3773438,
  },
  {
    Name: "Cynthia Lam",
    Region: "Asia",
    Country: "United Kingdom",
    City: "Cambridge",
    Latitude: 52.205337,
    Longitude: 0.121817,
  },
  {
    Name: "Jianzhe Yang",
    Region: "Asia",
    Country: "Ireland",
    City: "Dublin",
    Latitude: 53.3498053,
    Longitude: -6.2603097,
  },
  {
    Name: "Nympha Elisa M. Sia",
    Region: "Asia",
    Country: "Philippines",
    City: "Quezon City",
    Latitude: 14.6760413,
    Longitude: 121.0437003,
  },
  {
    Name: "Roudlotul Jannah",
    Region: "Asia",
    Country: "Indonesia",
    City: "Malang",
    Latitude: -7.9666204,
    Longitude: 112.6326321,
  },
  {
    Name: "Ryo Niwa",
    Region: "Asia",
    Country: "Japan",
    City: "Kyoto",
    Latitude: 35.011564,
    Longitude: 135.7681489,
  },
  {
    Name: "Seyeon Park",
    Region: "Asia",
    Country: "South Korea",
    City: "Gyeonggi",
    Latitude: 37.4138,
    Longitude: 127.5183,
  },
  {
    Name: "Shivaramakrishna Srinivasan",
    Region: "Asia",
    Country: "India",
    City: "Chennai",
    Latitude: 13.0826802,
    Longitude: 80.2707184,
  },
  {
    Name: "Shruti Sridhar",
    Region: "Asia",
    Country: "India",
    City: "Bangalore",
    Latitude: 12.9715987,
    Longitude: 77.5945627,
  },
  {
    Name: "Soumodeep Sarkar",
    Region: "Asia",
    Country: "India",
    City: "Manipal",
    Latitude: 13.3489958,
    Longitude: 74.7855559,
  },
  {
    Name: "Zhandong Jiao",
    Region: "Asia",
    Country: "China",
    City: "Beijing",
    Latitude: 39.9041999,
    Longitude: 116.4073963,
  },
  {
    Name: "Shrestha Rath",
    Region: "Asia",
    Country: "India",
    City: "Orissa",
    Latitude: 20.9516658,
    Longitude: 85.0985236,
  },
  {
    Name: "Abigail Conner",
    Region: "Europe",
    Country: "United Kingdom",
    City: "London",
    Latitude: 51.5073509,
    Longitude: -0.1277583,
  },
  {
    Name: "Assaf Kazakov",
    Region: "Europe",
    Country: "Israel",
    City: "Be'er Sheva",
    Latitude: 31.252973,
    Longitude: 34.791462,
  },
  {
    Name: "Claudia Sofía Troncone Clemente",
    Region: "Europe",
    Country: "Spain",
    City: "Madrid",
    Latitude: 40.4167754,
    Longitude: -3.7037902,
  },
  {
    Name: "Leandros Tsiotos",
    Region: "Europe",
    Country: "Greece",
    City: "Athens",
    Latitude: 37.9838096,
    Longitude: 23.7275388,
  },
  {
    Name: "Matthew Turk",
    Region: "Europe",
    Country: "United Kingdom",
    City: "Exeter",
    Latitude: 50.718412,
    Longitude: -3.533899,
  },
  {
    Name: "Sagi Sheinkman",
    Region: "Europe",
    Country: "Israel",
    City: "Haifa",
    Latitude: 32.7940463,
    Longitude: 34.989571,
  },
  {
    Name: "Srishty Rathee",
    Region: "Europe",
    Country: "Germany",
    City: "Bonn",
    Latitude: 50.73743,
    Longitude: 7.0982068,
  },
  {
    Name: "Athina Milona",
    Region: "Europe",
    Country: "Greece",
    City: "Athens",
    Latitude: 37.9838096,
    Longitude: 23.7275388,
  },
  {
    Name: "Carolina Elizondo",
    Region: "Global",
    Country: "Germany",
    City: "Heidelberg",
    Latitude: 49.3987524,
    Longitude: 8.6724335,
  },
  {
    Name: "Abril Diosdado Hernadez",
    Region: "Latin America",
    Country: "Mexico",
    City: "Monterrey",
    Latitude: 25.6866142,
    Longitude: -100.3161126,
  },
  {
    Name: "Ana Ruth Quintero",
    Region: "Latin America",
    Country: "Mexico",
    City: "Guadalajara",
    Latitude: 20.6596988,
    Longitude: -103.3496092,
  },
  {
    Name: "Heloísa Oss Boll",
    Region: "Latin America",
    Country: "Brazil",
    City: "Brasilia",
    Latitude: -15.826691,
    Longitude: -47.9218204,
  },
  {
    Name: "Jimmy Linhares",
    Region: "Latin America",
    Country: "Brazil",
    City: "Manaus",
    Latitude: -3.1190275,
    Longitude: -60.0217314,
  },
  {
    Name: "Minerva Castellanos",
    Region: "Latin America",
    Country: "Mexico",
    City: "Monterrey",
    Latitude: 25.6866142,
    Longitude: -100.3161126,
  },
  {
    Name: "Samantha García Arias",
    Region: "Latin America",
    Country: "Costa Rica",
    City: "San Jose",
    Latitude: 9.9280694,
    Longitude: -84.0907246,
  },
  {
    Name: "Heber Torres",
    Region: "Latin America",
    Country: "Mexico",
    City: "Monterrey",
    Latitude: 25.6866142,
    Longitude: -100.3161126,
  },
  {
    Name: "Erin Kim",
    Region: "North America",
    Country: "United States",
    City: "Boston",
    Latitude: 42.3600825,
    Longitude: -71.0588801,
  },
  {
    Name: "Ethan Levy",
    Region: "North America",
    Country: "United States",
    City: "Boston",
    Latitude: 42.3600825,
    Longitude: -71.0588801,
  },
  {
    Name: "Kaavya Ashok",
    Region: "North America",
    Country: "USA/Japan",
    City: "New York",
    Latitude: 40.75251,
    Longitude: -73.968287,
  },
  {
    Name: "Marie Peras",
    Region: "North America",
    Country: "USA",
    City: "San Francisco",
    Latitude: 37.7749295,
    Longitude: -122.4194155,
  },
  {
    Name: "Navya Lam",
    Region: "North America",
    Country: "USA",
    City: "Palo Alto",
    Latitude: 37.4418834,
    Longitude: -122.1430195,
  },
  {
    Name: "Nimaya De Silva",
    Region: "North America",
    Country: "Canada",
    City: "Lethbridge",
    Latitude: 49.6955856,
    Longitude: -112.8451364,
  },
  {
    Name: "Qitong Luan",
    Region: "North America",
    Country: "USA",
    City: "Gastonia",
    Latitude: 35.262082,
    Longitude: -81.1873005,
  },
  {
    Name: "Rocky An",
    Region: "North America",
    Country: "USA",
    City: "Ithaca",
    Latitude: 42.4439614,
    Longitude: -76.5018807,
  },
  {
    Name: "Tim Ho",
    Region: "North America",
    Country: "United States",
    City: "Durham",
    Latitude: 35.9940329,
    Longitude: -78.898619,
  },
  {
    Name: "Ansley Gnanapragasam",
    Region: "North America",
    Country: "Canada",
    City: "Laval",
    Latitude: 45.6066487,
    Longitude: -73.712409,
  },
];
